export const deviceManager = {
  devices: [
    {
      name: "Desktop",
      width: "",
      className: "fa fa-desktop",
    },
    {
      name: "Tablet",
      width: "768px",
      widthMedia: "810px",
      className: "fa fa-tablet",
    },
    {
      name: "Mobile",
      width: "320px",
      widthMedia: "480px",
      className: "fa fa-mobile",
    },
  ],
};
